import { Reducer } from 'redux';
import produce from 'immer';
import Message from '@naruto/naruto-reducers/src/stores/message';
import MESSAGE_ACTION from '@naruto/naruto-reducers/src/reducers/message/events';
import { CreateMessageReducerParams, MessageActionTypes } from './types';

export function createMessageReducer(params: CreateMessageReducerParams): Reducer<Message, MessageActionTypes> {
  return (state = params.initialState, action: MessageActionTypes): Message =>
    produce(state, _draft => {
      const draft = _draft;
      switch (action.type) {
        case MESSAGE_ACTION.SET_MESSAGE_INITIALIZE:
          draft.initialize();
          break;
        case MESSAGE_ACTION.SET_MESSAGE_DIALOG:
          draft.updateMessageDialogList(action.dialog);
          break;
        case MESSAGE_ACTION.REMOVE_MESSAGE_DIALOG:
          draft.removeMessageDialog();
          break;
        case MESSAGE_ACTION.SET_MESSAGE_CONFIRM:
          draft.updateMessageConfirmList(action.confirm);
          break;
        case MESSAGE_ACTION.REMOVE_MESSAGE_CONFIRM:
          draft.removeMessageConfirm();
          break;
        case MESSAGE_ACTION.SET_MESSAGE_SNACK:
          draft.updateMessageSnackList(action.snack);
          break;
        case MESSAGE_ACTION.REMOVE_MESSAGE_SNACK:
          draft.removeMessageSnack();
          break;
        default:
          break;
      }
    });
}
